<template>
  <div class="container pb-4">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <h2 class="align-center justify-content-center talent-top">
          Ready to jump onto the path of
          <a
            href="https://docs.google.com/presentation/d/1tKibguPrj8yQxlz8kyJgV6BCzxOTH-bERbRDEuiF22M/edit?usp=sharing"
            target="_blank"
            class="hyper-growth-link"
            >Hyper-Growth</a
          >?
        </h2>
      </div>
    </div>
    <div class="row justify-content-center"></div>
    <div class="row justify-content-center button-container">
      <div
        class="col-md-auto col-6 d-flex align-items-center justify-content-center btn-container"
      >
        <a
          @click="scrollToSectionFullTime('#careers')"
          class="button btn btn-primary btn-lg btn-apply-now btn1-apply"
          >Apply - Full Time</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import "vue3-carousel/dist/carousel.css";

export default {
  name: "RecentWork",
  components: {},
  methods: {
    scrollToSectionFullTime(sectionId) {
      const section = document.querySelector(sectionId);
      if (section) {
        const offset = section.offsetTop - 50;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    },
    scrollToSectionInternship(sectionId) {
      const section = document.querySelector(sectionId);
      if (section) {
        const offset = section.offsetTop + 2700;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    },
  },
  setup() {
    const router = useRouter();

    return {
      router,
    };
  },
};
</script>

<style scoped>
.container {
  background: linear-gradient(
    91.49deg,
    rgba(244, 120, 38, 0.07) 0%,
    rgba(240, 123, 34, 0.062) 100.16%
  );
  border-radius: 20px;
}

.talent-top {
  margin-top: 25px;
  font-size: 36px;
  font-weight: 700 !important;
  text-align: center;
  font-style: normal;
}

.row2 {
  justify-content: center;
  text-align: center;
  margin-top: 0.5vh;
}

.row3 {
  opacity: 1;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.btn {
  white-space: nowrap;
  font-size: 1.8rem;
  padding: 1.5rem 3rem;
  font-weight: 700;
}

.btn-primary {
  white-space: nowrap;
  margin-top: 2vh;
  font-size: 1.8rem;
  font-weight: 700;
  color: #fff !important;
  border-radius: 80px !important;
  transition: all 0.3s ease;
  padding: 1.5rem 3rem;
  min-width: 250px;
}

.btn1-apply {
  background-color: #f28636;
  border: none;
  font-size: 1.8rem;
  padding: 1.5rem 3rem;
}

.btn1-apply:hover {
  background-color: #ff9a56;
  border: none;
  box-shadow: 0 0 20px rgba(244, 119, 38, 0.6), 0 0 40px rgba(244, 119, 38, 0.4),
    0 0 60px rgba(244, 119, 38, 0.2);
  transform: scale(1.05);
  transition: all 0.3s ease;
}

.btn2-intern {
  background-color: rgba(244, 120, 38, 0.1);
  border-color: #f28636;
  margin-left: 31%;
  box-sizing: border-box;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  border: 2px solid rgba(244, 123, 42, 1);
  border-radius: 80px;
  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}

.btn2-intern:hover {
  background-color: rgba(244, 120, 38, 0.1);
  border-color: #f28636;
  opacity: 0.7;
}

.hyper-growth-link {
  color: #f47726;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  font-weight: 800;
  transition: all 0.3s ease;
  cursor: pointer;
  text-shadow: 0 2px 4px rgba(244, 119, 38, 0.3);
}

.hyper-growth-link:hover {
  color: #ff9a56;
  text-decoration: underline;
  text-decoration-thickness: 3px;
  text-underline-offset: 4px;
  transform: scale(1.05);
  text-shadow: 0 4px 8px rgba(244, 119, 38, 0.5);
}

@media screen and (max-width: 768px) {
  .button-container {
    margin: 4px 8px !important;
  }
  .btn2-intern {
    margin-left: 0 !important;
  }

  .btn-apply-now {
    padding: 5px 13px !important;
    max-width: 160px !important;
    height: 30px !important;
    font-size: 14px;
    line-height: 110%;
    letter-spacing: -0.186749px;
  }
  .btn1-apply {
    padding: 7px 13px !important;
  }

  .talent-desc-container {
    padding: 0 !important;
    margin: 0 !important;
  }

  .talent-desc {
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    /* or 22px */
    width: 100% !important;
    max-width: 100% !important;
    text-align: center;
  }

  .btn-container {
    margin: 0 !important;
  }

  btn-container:first-child {
    margin-right: 16px;
  }
}

@media screen and (max-width: 400px) {
  .btn-apply-now {
    padding: 5px 14px !important;
    max-width: 140px !important;
    height: 30px !important;
    font-size: 12px;
    line-height: 110%;
    letter-spacing: -0.186749px;
  }
  .btn1-apply {
    padding: 7px 16px !important;
  }
}

@media screen and (max-width: 980px) {
  .talent-top {
    margin-top: 16px;
    font-size: 24px;
    font-weight: 700 !important;
    text-align: center;
    font-style: normal;

    line-height: 120%;
    padding: 0 12px;
  }

  .row3 {
    opacity: 1;
    font-size: 18px;
  }
}
</style>
